'use client'

import { getSupabaseClient } from '@/lib/supabase-client'

type ValidatedSession = {
  token: string
}

async function readValidatedSession(): Promise<ValidatedSession | null> {
  const supabase = getSupabaseClient()
  const { data: { user }, error } = await supabase.auth.getUser()
  if (error || !user) {
    return null
  }

  const { data: { session }, error: sessionError } = await supabase.auth.getSession()
  if (sessionError || !session?.access_token) {
    return null
  }

  return { token: session.access_token }
}

/**
 * Returns a bearer token validated (and refreshed if needed) against Supabase.
 * Prefer this over reading getSession() directly before API calls.
 */
export async function getValidatedAccessToken(): Promise<string | null> {
  const validated = await readValidatedSession()
  return validated?.token ?? null
}
